<div [ngClass]="{
    'w-100 full-height-mobile position-relative z-max': !viewportService.isLargeViewPort(),
    'h-100': viewportService.isLargeViewPort()}"
    class="d-flex flex-column w-100 overflow-y-auto overflow-x-hidden no-scroll-bar background-white z-max">
    <div [ngClass]="{'w-100': !viewportService.isLargeViewPort(), 'width-400px': viewportService.isLargeViewPort()}"
         class="height-100px row p-0 m-0 background-primary-blue w-100 border-bottom border-dark-subtle p-3 z-max d-flex justify-content-center align-items-center">
        <div (click)="back()" class="col-2 pt-4 pb-4 btn text-reset d-flex justify-content-center align-items-center">
            <i class="color-white fa-solid fa-chevron-left fa-xl p-3"></i>
        </div>
        <div class="col-8">
            <div class="row d-flex justify-content-center align-items-center">
                <div class="col-auto fs-main text-center color-white">Paddocks ({{ paddockStore.entities().length }})</div>
            </div>
        </div>
        <div (click)="close()" class="pointer text-reset col-2 d-flex justify-content-center align-items-center">
            <i class="color-white fa-solid fa-x fa-xl"></i>
        </div>
    </div>
    <div class="d-flex flex-column gap-3 p-3 w-100 background-white overflow-y-auto overflow-x-hidden no-scroll-bar">
        <app-generic-button
            (click)="addPaddocks()"
            description="Add paddocks"
            [alwaysShowText]="true"
            [buttonText]="'Add paddocks'"
            [disabled]="!userStore.canEdit()"
            [primaryIcon]="'fa-solid fa-plus'"/>
        <div class="d-flex flex-column gap-2">
            @for (paddock of paddockStore.entities(); track paddock.id) {
                <app-paddock-button
                    [paddock]="paddock"/>
            }
        </div>
    </div>
</div>
